import * as Yup from 'yup';
import { TFormValues } from '../types.ts';
import {
  phoneValidation,
  emailValidation,
  conditionalClientTypeValidation,
} from '../validationUtils.ts';
import { errorMessages } from '~/constants/errorMessages.js';

export const validationSchemaClientSubmit: Yup.ObjectSchema<TFormValues> = Yup.object({
  financialServices: Yup.boolean().defined(),
  financialServicesClientType: conditionalClientTypeValidation('financialServices')
    .nullable()
    .defined(),
  cardAccess: Yup.boolean().defined(),
  businessRelationship: Yup.boolean().defined(),
  businessRelationshipClientType: conditionalClientTypeValidation('businessRelationship')
    .nullable()
    .defined(),
  creditBureauData: Yup.boolean().defined(),
  phone: phoneValidation.defined(),
  email: emailValidation.defined(),
  atLeastOneCheckbox: Yup.boolean().defined().test(
    'at-least-one-checkbox',
    errorMessages.AT_LEAST_ONE_SELECTED,
    function () {
      const { cardAccess } = this.parent as TFormValues;
      return (
        cardAccess ||
        this.createError({
          path: 'atLeastOneCheckbox',
          message: errorMessages.AT_LEAST_ONE_SELECTED,
        })
      );
    }
  ),
});
